// extracted by mini-css-extract-plugin
export var brandLockup = "_mg-5";
export var brandLogo = "_mg-6";
export var bullet = "_mg-1i";
export var bulletText = "_mg-1h";
export var bullets = "_mg-1c";
export var callout = "_mg-12";
export var calloutBody = "_mg-14";
export var calloutLabel = "_mg-13";
export var checkIcon = "_mg-1e";
export var checkList = "_mg-1b";
export var checkSvg = "_mg-1f";
export var checkText = "_mg-1g";
export var choiceCard = "_mg-x";
export var choiceDescription = "_mg-10";
export var choiceIcon = "_mg-11";
export var choiceText = "_mg-y";
export var choiceTitle = "_mg-z";
export var closeButton = "_mg-d";
export var codeText = "_mg-28";
export var compactPage = "_mg-f";
export var content = "_mg-9";
export var contentColumn = "_mg-3";
export var coverageCard = "_mg-o";
export var coverageDescription = "_mg-24";
export var coverageTitle = "_mg-23";
export var eyebrow = "_mg-i";
export var fieldCard = "_mg-m";
export var fieldDescription = "_mg-r";
export var fieldError = "_mg-s";
export var fieldHeader = "_mg-p";
export var fieldTitle = "_mg-q";
export var finalNote = "_mg-29";
export var footer = "_mg-a";
export var fulfillmentBody = "_mg-1u";
export var fulfillmentBodyText = "_mg-1v";
export var fulfillmentRow = "_mg-1r";
export var fulfillmentRows = "_mg-1q";
export var fulfillmentTitle = "_mg-1t";
export var header = "_mg-4";
export var heading = "_mg-h";
export var helperText = "_mg-1k";
export var indented = "_mg-1x";
export var inlineLink = "_mg-26";
export var inlineTitle = "_mg-2a";
export var intro = "_mg-k";
export var linkPreview = "_mg-1z";
export var listItem = "_mg-1d";
export var main = "_mg-1";
export var marketingImage = "_mg-c";
export var marketingPanel = "_mg-b";
export var modal = "_mg-0";
export var noteBody = "_mg-v";
export var noteBodyText = "_mg-w";
export var noteCard = "_mg-n";
export var noteIcon = "_mg-t";
export var noteTitle = "_mg-u";
export var numberBadge = "_mg-2e";
export var numberedStep = "_mg-2c";
export var numberedStepBody = "_mg-2f";
export var numberedStepCta = "_mg-2d";
export var numberedStepDescription = "_mg-2h";
export var numberedStepTitle = "_mg-2g";
export var numberedSteps = "_mg-2b";
export var page = "_mg-e";
export var playCircle = "_mg-18";
export var playIcon = "_mg-19";
export var policyBody = "_mg-21";
export var policyHeader = "_mg-20";
export var policyPreview = "_mg-1y";
export var policyTitle = "_mg-22";
export var progressFill = "_mg-8";
export var progressTrack = "_mg-7";
export var pseudoLink = "_mg-25";
export var pseudoLinkIcon = "_mg-27";
export var rowHeader = "_mg-1s";
export var section = "_mg-g";
export var shell = "_mg-2";
export var statusIconSuccess = "_mg-1m";
export var statusIconSvg = "_mg-1o";
export var statusIconWarning = "_mg-1n";
export var statusRow = "_mg-1l";
export var statusText = "_mg-1p";
export var stepTitle = "_mg-j";
export var strongText = "_mg-1w";
export var subHeading = "_mg-l";
export var videoEmbed = "_mg-16";
export var videoIframe = "_mg-17";
export var videoLabel = "_mg-1a";
export var videoPlaceholder = "_mg-15";
export var warningIcon = "_mg-1j";